import { createFileRoute } from "@tanstack/react-router";
import { tabSearch } from "@/app/tabs";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { SettingsTabs, settingsSections } from "@/features/settings";
import { requirePerm } from "@/lib/auth/guards";

export const Route = createFileRoute("/_authenticated/settings")({
  // Retired `?tab=` ids resolve to the tab that absorbed them — `app/tabs.ts`.
  validateSearch: tabSearch("settings"),
  beforeLoad: requirePerm("admin.staff"),
  component: SettingsRoute,
});

/**
 * The tab strip over the section the address names. The strip is always drawn —
 * it is the only door into the sections, since the nav link carries no `?tab=`.
 * An address with no `?tab=` keeps the pending page as the content under it
 * (25-09-2026 render guide: bare /settings stays the pending page), with no
 * tab active. An id the registry does not hold keeps the same pending surface
 * behind a strip that still names every section.
 */
function SettingsRoute() {
  const { tab } = Route.useSearch();
  const sections = settingsSections.use();
  const section = sections.find((item) => item.id === tab);
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <SettingsTabs active={section?.id ?? ""} />
      {section ? <section.Component /> : <PendingSurface titleKey="nav.settings" />}
    </div>
  );
}
